import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React, { FC, useRef, useState } from 'react';
import { Formik } from 'formik';
import { InitData } from '../types';
import { IFormData } from '../../../components/FormHelper/FormHelper.types';
import { Button } from '../../../components/Button';
import { STYLE_VARS } from '../../../constants/style-vars';
import { Image } from '../../../components/Image';
import { TextInput } from '../../../components/TextInput/TextInput';
import {
  launchImageLibrary,
  launchCamera,
  Asset,
} from 'react-native-image-picker';
import DepartmentSelect from './DepartmentSelect';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { SHARE_STYLE } from '../../../constants/share-style';
import { COLORS, FONTS } from '../../../constants';
import * as yup from 'yup';
import { IS_WEB } from '../../../constants/platform';
import { addBase64Prefix } from '../../../services/addBase64Prefix';
import { close_icon } from '../../../assets/base64';
import { Alert } from '../../../services/alert';

interface FeedbackFormProps {
  initData: InitData;
  handleSubmit: (data: IFormData) => void;
}

const FeedbackForm: FC<FeedbackFormProps> = ({ initData, handleSubmit }) => {
  const isDesktop = useIsDesktop();
  const inputFileRef = useRef<HTMLInputElement>(null);
  const [preview, setPreview] = useState<string | undefined>('');

  return (
    <View>
      {isDesktop() && (
        <View style={{ marginBottom: 20 }}>
          <Text style={SHARE_STYLE.titleText}>Submit Your Feedback</Text>
        </View>
      )}
      <Formik
        initialValues={initData}
        onSubmit={(values, { resetForm }) => {
          handleSubmit(values);
          resetForm();
        }}
        validationSchema={yup.object().shape({
          location: yup.string().required('Please select a location.'),
          message: yup.string().required('Please enter a message.'),
        })}
      >
        {({
          handleSubmit,
          handleChange,
          values,
          errors,
          touched,
          setValues,
          setFieldValue,
        }) => (
          <View
            style={{ flexDirection: 'column', rowGap: 30, marginBottom: 50 }}
          >
            <DepartmentSelect
              selectItem={values.department}
              onSelect={(value) => {
                handleChange('department')(value);
              }}
              otherText={values.otherText}
              onChangeOtherText={(text) => {
                handleChange('otherText')(text);
              }}
              style={{ flexDirection: isDesktop() ? 'row' : undefined }}
            />
            <View
              style={{
                flexDirection: isDesktop() ? 'row' : undefined,
              }}
            >
              <Text
                style={[
                  styles.titleText,
                  { marginBottom: 10, width: isDesktop() ? '25%' : undefined },
                ]}
              >
                Location
              </Text>
              <View style={{ width: isDesktop() ? '75%' : undefined }}>
                <View
                  style={{
                    borderWidth: 0.5,
                    borderColor: STYLE_VARS.fccDarkGrey,
                  }}
                >
                  <TextInput
                    placeholder="ENTER YOUR LOCATION"
                    onChangeText={handleChange('location')}
                    value={values.location}
                    placeholderTextColor={STYLE_VARS.fccDarkGrey}
                    style={[styles.input]}
                  />
                </View>
                {errors.location && touched.location ? (
                  <View style={{ marginTop: 5 }}>
                    <Text
                      style={{
                        color: COLORS.RED,
                        fontSize: 14,
                        fontFamily: FONTS.IowanOldStyleBTRoman,
                      }}
                    >
                      {errors.location}
                    </Text>
                  </View>
                ) : null}
              </View>
            </View>
            {isDesktop() ? (
              <View style={{ flexDirection: 'row' }}>
                <View
                  style={{
                    flexDirection: 'column',
                    marginBottom: 10,
                    width: '25%',
                  }}
                >
                  <Text style={[styles.titleText]}>Upload photo</Text>
                  <Text style={[styles.titleText]}>(if applicable)</Text>
                </View>
                <View style={{ width: '75%' }}>
                  <View
                    style={{
                      borderWidth: 1,
                      borderColor: STYLE_VARS.fccDarkGrey,
                      borderStyle: 'solid',
                      borderTopEndRadius: 10,
                      borderBottomEndRadius: 10,
                    }}
                  >
                    <TouchableOpacity
                      onPress={() => {
                        if (inputFileRef.current) {
                          inputFileRef.current.click();
                        }
                      }}
                    >
                      <label
                        style={{
                          width: '100%',
                          height: 40,
                          flexDirection: 'row',
                          justifyContent: 'end',
                          display: 'flex',
                        }}
                      >
                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              paddingHorizontal: 10,
                              paddingVertical: 13,
                              color: STYLE_VARS.fccDarkerGrey,
                              fontSize: 12,
                              letterSpacing: 0.8,
                              fontWeight: '500',
                              fontFamily: FONTS.IowanOldStyleBTRoman,
                            }}
                          >
                            {values.file?.name}
                          </Text>
                        </View>
                        <div style={{ width: '20%', margin: 0 }}>
                          <Button
                            style={[
                              STYLE_VARS.fullWGreenButton,
                              {
                                height: 40,
                                paddingVertical: 13,
                              },
                            ]}
                            text={'BROWSE'}
                            onPress={() => {
                              if (inputFileRef.current) {
                                inputFileRef.current.click();
                              }
                            }}
                          />
                        </div>
                      </label>
                    </TouchableOpacity>
                  </View>
                </View>
              </View>
            ) : (
              <View>
                <Text
                  style={[
                    styles.titleText,
                    { marginBottom: 10, textAlign: 'center' },
                  ]}
                >
                  Tap to select
                </Text>
                <View style={{ flexDirection: 'row', gap: 20 }}>
                  <Button
                    text="SELECT PHOTO"
                    style={STYLE_VARS.fullWGreenButton}
                    onPress={async () => {
                      if (IS_WEB) {
                        if (inputFileRef.current) {
                          inputFileRef.current.click();
                        }
                      } else {
                        {
                          /* Disable on website */
                        }
                        // const result = await launchImageLibrary({
                        //   mediaType: 'photo',
                        // });
                        // setValues(
                        //   {
                        //     ...values,
                        //     file: result.assets && result.assets[0],
                        //   },
                        //   false
                        // );
                        // setPreview(result.assets && result.assets[0].uri);
                      }
                    }}
                  />
                  <Button
                    text="TAKE PHOTO"
                    style={STYLE_VARS.fullWGreenButton}
                    onPress={async () => {
                      {
                        /* Disable on website */
                      }
                      // const result = await launchCamera({
                      //   mediaType: 'photo',
                      // });
                      // setValues(
                      //   {
                      //     ...values,
                      //     file: result.assets && result.assets[0],
                      //   },
                      //   false
                      // );
                      // setPreview(result.assets && result.assets[0].uri);
                    }}
                  />
                </View>
              </View>
            )}
            {IS_WEB && (
              <input
                type={'file'}
                id={'photo_upload'}
                name={'file'}
                ref={inputFileRef}
                style={{
                  width: 0.1,
                  height: 0.1,
                  opacity: 0,
                  overflow: 'hidden',
                  position: 'absolute',
                  zIndex: -1,
                }}
                accept="image/png, image/jpg, image/jpeg"
                onChange={(e) => {
                  if (e.currentTarget.files && e.currentTarget.files[0]) {
                    setFieldValue('file', e.currentTarget.files[0]);
                    const objectUrl = URL.createObjectURL(
                      e.currentTarget.files[0]
                    );
                    setPreview(objectUrl);
                  }
                }}
              />
            )}
            {values.file && preview && (
              <View style={{ marginTop: 10 }}>
                <Image
                  source={{ uri: preview }}
                  style={{
                    width: '100%',
                    height: 500,
                    resizeMode: 'contain',
                  }}
                />
                <TouchableOpacity
                  style={{
                    width: 30,
                    height: 30,
                    backgroundColor: STYLE_VARS.kccDanger,
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'absolute',
                    right: -10,
                    borderRadius: 20,
                    top: 0,
                  }}
                  onPress={() => {
                    Alert.alert(
                      'Delete Image',
                      'Are you sure you want to delete this image?',
                      [
                        {
                          text: 'Cancel',
                          onPress: () => {},
                        },
                        {
                          text: 'Confirm',
                          onPress: () => {
                            setValues(
                              {
                                ...values,
                                file: undefined,
                              },
                              false
                            );
                            setPreview('');
                          },
                        },
                      ]
                    );
                  }}
                >
                  <Image
                    source={
                      IS_WEB
                        ? addBase64Prefix(close_icon)
                        : require('../../../assets/close-icon.png')
                    }
                    style={{
                      width: 14,
                      height: 14,
                      resizeMode: 'cover',
                      tintColor: 'white',
                    }}
                  />
                </TouchableOpacity>
              </View>
            )}
            <View>
              <View
                style={{
                  borderWidth: 0.5,
                  borderColor: STYLE_VARS.fccDarkGrey,
                }}
              >
                <TextInput
                  placeholder={'MESSAGE'}
                  onChangeText={handleChange('message')}
                  value={values.message}
                  textAlignVertical="top"
                  multiline
                  placeholderTextColor={STYLE_VARS.fccDarkGrey}
                  style={[styles.input, { height: 100 }]}
                />
              </View>
              {errors.message && touched.message ? (
                <View style={{ marginTop: 5 }}>
                  <Text
                    style={{
                      color: COLORS.RED,
                      fontSize: 14,
                      fontFamily: FONTS.IowanOldStyleBTRoman,
                    }}
                  >
                    {errors.message}
                  </Text>
                </View>
              ) : null}
            </View>
            <View style={{ alignSelf: 'center' }}>
              <Button
                text="SUBMIT"
                style={STYLE_VARS.blueButton}
                onPress={() => {
                  handleSubmit();
                }}
              />
            </View>
          </View>
        )}
      </Formik>
    </View>
  );
};

export default FeedbackForm;

const styles = StyleSheet.create({
  input: {
    height: 40,
    paddingHorizontal: 10,
    alignItems: 'flex-start',
    paddingVertical: 10,
    color: STYLE_VARS.fccDarkerGrey,
    fontSize: 12,
    letterSpacing: 0.8,
    fontWeight: '500',
    fontFamily: FONTS.IowanOldStyleBTRoman,
  },
  titleText: {
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
    fontFamily: FONTS.IowanOldStyleBTRoman,
    fontSize: 13,
    fontWeight: '500',
  },
});
